import { DataBean } from "../DataBean";

export class ProductSupplier extends DataBean {
  public async getProductSupplierCatalog(
    idAccount: number,
    idProduct: number
  ): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "java.util.List_getProductSupplierCatalog_Number_Number",
      [idAccount, idProduct]
    );
  }

  public async deleteProductSupplier(idProductSupplier: number): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "void_deleteProductSupplier_Number",
      [idProductSupplier]
    );
  }

  public async getProductSupplierConstants(arg: number): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "java.util.List_getProductSupplierConstants_Number",
      [arg]
    );
  }

  public async updateProductSupplier(bean: any): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "com.quickdataerp.bean.inventory.ProductSupplier_updateProductSupplier_com.quickdataerp.bean.inventory.ProductSupplier",
      [
        {
          DataBeanProperties: bean,
          DataBeanName: "com.quickdataerp.bean.inventory.ProductSupplier",
        },
      ]
    );
  }
}
